import {
  FORM_NODE_NAME,
  FORM_TEXT_FIELD_NODE_NAME,
  FORM_EMAIL_FIELD_NODE_NAME,
  FORM_CONSENT_FIELD_NODE_NAME,
  FORM_DROPDOWN_FIELD_NODE_NAME,
  FORM_PHONE_FIELD_NODE_NAME,
  FORM_SELECTION_FIELD_NODE_NAME,
  FORM_SUBMIT_BUTTON_NODE_NAME,
} from '../../utils/constants';

/**
 * I am simplifying the whole registry for now. I think we should expand it to be one registry for all node types.
 * Containing helpful node config and meta data that can be used everywhere.
 */

export const FORM_FIELDS = [
  FORM_TEXT_FIELD_NODE_NAME,
  FORM_EMAIL_FIELD_NODE_NAME,
  FORM_CONSENT_FIELD_NODE_NAME,
  FORM_DROPDOWN_FIELD_NODE_NAME,
  FORM_PHONE_FIELD_NODE_NAME,
  FORM_SELECTION_FIELD_NODE_NAME,
];

export const FORM_CONTROLS = [FORM_SUBMIT_BUTTON_NODE_NAME];

export const FORM_SUB_NODES = [...FORM_FIELDS, ...FORM_CONTROLS];

/**
 * Check if a node is a Form node by its displayName.
 *
 * @param displayName - The displayName of the node to check
 * @returns true if the node is a Form
 */
export const isFormNode = (displayName: string): boolean => {
  return displayName === FORM_NODE_NAME;
};

/**
 * Check if a node is a form control by the node displayName.
 * Form controls include input fields and buttons that belong to a Form component.
 *
 * @param displayName - The displayName of the node to check
 */
export const isFormControlNode = (displayName: string): boolean => {
  return FORM_CONTROLS.includes(displayName);
};

/**
 * Check if a node is a form input field by the node displayName.
 * This excludes submit buttons and other non-input form fields.
 *
 * TODO: There may be a better way to make this distinction, but leaving it for now.
 *
 * @param displayName - The displayName of the node to check
 * @returns true if the node is a form input field (not a button)
 */
export const isFormFieldNode = (displayName: string): boolean => {
  return FORM_FIELDS.includes(displayName);
};

/**
 * Check if a node is any form sub-node by the node displayName.
 *
 * @param displayName - The displayName of the node to check
 * @returns true if the node is a form sub-node
 */
export const isFormSubNode = (displayName: string): boolean => {
  return FORM_SUB_NODES.includes(displayName);
};

/**
 * Check if a node is any form input node by the node displayName.
 *
 * @param displayName - The displayName of the node to check
 * @returns false if the node is a submit button (not an input node)
 * @returns true if the node is a form input node
 */
export const isFormInputNode = (displayName: string): boolean => {
  if (displayName === FORM_SUBMIT_BUTTON_NODE_NAME) return false;
  return FORM_SUB_NODES.includes(displayName);
};
